import createModel, { Mapped } from "@/__main__/data-model.mjs";

const apiModelValidation = createModel({
  ...Mapped({
    key: String,
    value: {
      apiKey: String,
      cost: Number,
      description: String,
      name: String,
      rarity: Number,
      type: String,
    },
  }),
});

function transform(data) {
  return apiModelValidation(data);
}

export default transform;
